import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export function ReferralRedirectPage() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!code) {
      navigate('/login', { replace: true });
      return;
    }

    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const apiUrl = `${supabaseUrl}/functions/v1/track-referral-click?code=${encodeURIComponent(code)}`;

    fetch(apiUrl)
      .then(res => res.json())
      .then(result => {
        if (result.valid) {
          document.cookie = `referral_code=${code}; max-age=${30 * 24 * 60 * 60}; path=/; samesite=lax${location.protocol === 'https:' ? '; secure' : ''}`;
        }
      })
      .catch(() => {})
      .finally(() => {
        navigate('/login', { replace: true });
      });
  }, [code]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mx-auto mb-4" />
        <p className="text-gray-500 text-sm">Redirection en cours...</p>
      </div>
    </div>
  );
}
